import React from 'react';
import { useLocation } from 'react-router-dom';
import { Section, SectionedPage, Users } from '@core/components/ui';
import { useAuth } from '@core/contexts/AuthContext';
import { UserRole, isAtLeast } from '@core/enum/userRole';
import { Forbidden } from '@core/pages';
import { MATERIAL_KIND_LABELS, MaterialKind } from '../../enum/materialKind';
import { VestmentCategory } from '../../enum/vestmentCategory';
import { navItems } from '../../navigation';
import AlbCollars from './AlbCollars';
import Albs from './Albs';
import Chasubles from './Chasubles';
import Colors from './Colors';
import Fabrics from './Fabrics';
import MaterialSettings from './MaterialSettings';
import Sizes from './Sizes';
import Stoles from './Stoles';
import VestmentCategoryList from './VestmentCategoryList';

const Settings: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const isAdmin = user ? isAtLeast(user.role, UserRole.Admin) : false;

  if (!isAdmin && location.pathname.startsWith('/settings/users')) {
    return <Forbidden />;
  }

  return (
    <SectionedPage navItems={navItems} path="/settings/*" basePath="/settings">
      <Section id="chasubles" label="Chasubles" path="/settings/chasubles">
        <Chasubles />
      </Section>
      <Section id="stoles" label="Stoles" path="/settings/stoles">
        <Stoles />
      </Section>
      <Section id="albs" label="Albs" path="/settings/albs">
        <Albs />
      </Section>
      <Section id="mitres" label="Mitres" path="/settings/mitres">
        <VestmentCategoryList category={VestmentCategory.Mitre} />
      </Section>
      <Section id="sizes" label="Sizes" path="/settings/sizes">
        <Sizes />
      </Section>
      <Section
        id="alb-collars"
        label="Alb Collars"
        path="/settings/alb-collars"
      >
        <AlbCollars />
      </Section>
      <Section id="fabrics" label="Fabrics" path="/settings/fabrics">
        <Fabrics />
      </Section>
      <Section id="threads" label="Threads" path="/settings/threads">
        <MaterialSettings
          kind={MaterialKind.Thread}
          labels={MATERIAL_KIND_LABELS[MaterialKind.Thread]}
        />
      </Section>
      <Section id="trimmings" label="Trimmings" path="/settings/trimmings">
        <MaterialSettings
          kind={MaterialKind.Trimming}
          labels={MATERIAL_KIND_LABELS[MaterialKind.Trimming]}
        />
      </Section>
      <Section id="galoons" label="Galoons" path="/settings/galoons">
        <MaterialSettings
          kind={MaterialKind.Galoon}
          labels={MATERIAL_KIND_LABELS[MaterialKind.Galoon]}
        />
      </Section>
      <Section id="cords" label="Cords" path="/settings/cords">
        <MaterialSettings
          kind={MaterialKind.Cord}
          labels={MATERIAL_KIND_LABELS[MaterialKind.Cord]}
        />
      </Section>
      <Section id="tassels" label="Tassels" path="/settings/tassels">
        <MaterialSettings
          kind={MaterialKind.Tassel}
          labels={MATERIAL_KIND_LABELS[MaterialKind.Tassel]}
        />
      </Section>
      <Section id="colors" label="Colors" path="/settings/colors">
        <Colors />
      </Section>
      {isAdmin ? (
        <Section id="users" label="Users" path="/settings/users">
          <Users />
        </Section>
      ) : null}
    </SectionedPage>
  );
};

export default Settings;
